<template>
  <!-- order-package -->
  <section class="article" id="packageGroup">
    <div class="container">
      <div class="col-12 head">
        <h2 class="title">{{$t('compare_packages["compare_packages"]')}}</h2>
        <p class="text pb-5">{{$t('compare_packages["description"]')}}</p>
      </div>
      <div class="package-items">
        <div class="row">
          <table id="tabela_porownanie">
            <tbody>
            <tr>
              <td></td>
              <td id="porownanie_td_1" class="table-header">{{$t('sets["basic"]')}}</td>
              <td id="porownanie_td_2" class="table-header">{{$t('sets["advanced"]')}}</td>
              <td id="porownanie_td_3" class="table-header">{{$t('sets["premium"]')}}</td>
            </tr>

            <tr>
              <td class="attribute">{{$t('compare_packages["attribute1"]')}}</td>
              <td><img src="../assets/img/porownanie1.png"></td>
              <td><img src="../assets/img/porownanie2.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="attribute">{{$t('compare_packages["attribute2"]')}}</td>
              <td><img src="../assets/img/porownanie1.png"></td>
              <td><img src="../assets/img/porownanie2.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="attribute">{{$t('compare_packages["attribute3"]')}}</td>
              <td><img src="../assets/img/porownanie0.png"></td>
              <td><img src="../assets/img/porownanie2.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="attribute">{{$t('compare_packages["attribute4"]')}}</td>
              <td><img src="../assets/img/porownanie0.png"></td>
              <td><img src="../assets/img/porownanie2.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="attribute">{{$t('compare_packages["attribute5"]')}}</td>
              <td><img src="../assets/img/porownanie0.png"></td>
              <td><img src="../assets/img/porownanie2.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="attribute">{{$t('compare_packages["attribute7"]')}}</td>
              <td><img src="../assets/img/porownanie0.png"></td>
              <td><img src="../assets/img/porownanie0.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="attribute">{{$t('compare_packages["attribute8"]')}}</td>
              <td><img src="../assets/img/porownanie0.png"></td>
              <td><img src="../assets/img/porownanie0.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="attribute">{{$t('compare_packages["attribute6"]')}}</td>
              <td class="text">
                <div class="old-price">{{$t('sets["basic_old_price"]')}}</div>
                <div>{{$t('sets["basic_price"]')}}</div>
              </td>
              <td class="text">
                <div class="old-price">{{$t('sets["advanced_old_price"]')}}</div>
                <div>{{$t('sets["advanced_price"]')}}</div>
              </td>
              <td class="text">
                <div class="old-price">{{$t('sets["premium_old_price"]')}}</div>
                <div>{{$t('sets["premium_price"]')}}</div>
              </td>
            </tr>

            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>
                  <a class="porownanie_td_order" type="button" target="_blank" :href="$t('sets.basic_link')">
                    {{$t('order')}}
                  </a>
              </td>
              <td>
                <a class="porownanie_td_order" type="button" target="_blank" :href="$t('sets.advanced_link')">
                    {{$t('order')}}
                  </a>
              </td>
              <td>
                <a class="porownanie_td_order" type="button" target="_blank" :href="$t('sets.premium_link')">
                    {{$t('order')}}
                  </a>
              </td>
            </tr>

            </tbody>
          </table>
        </div>
      </div>

      <div class="package-items">
        <div class="row">
          <table id="tabela_porownanie" class="tabela_porownanie_mobilna">
            <tbody>
            <tr>
              <td class="porownanie_td_0"></td>
              <td id="porownanie_td_1">{{$t('sets["basic"]')}}</td>
              <td id="porownanie_td_2">{{$t('sets["advanced"]')}}</td>
              <td id="porownanie_td_3">{{$t('sets["premium"]')}}</td>
            </tr>
            <tr>
              <td class="porownanie_td_0">{{$t('compare_packages["attribute1"]')}}</td>
              <td><img src="../assets/img/porownanie1.png"></td>
              <td><img src="../assets/img/porownanie2.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="porownanie_td_0">{{$t('compare_packages["attribute2"]')}}</td>
              <td><img src="../assets/img/porownanie1.png"></td>
              <td><img src="../assets/img/porownanie2.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="porownanie_td_0">{{$t('compare_packages["attribute3"]')}}</td>
              <td><img src="../assets/img/porownanie0.png"></td>
              <td><img src="../assets/img/porownanie2.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="porownanie_td_0">{{$t('compare_packages["attribute4"]')}}</td>
              <td><img src="../assets/img/porownanie0.png"></td>
              <td><img src="../assets/img/porownanie2.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="porownanie_td_0">{{$t('compare_packages["attribute5"]')}}</td>
              <td><img src="../assets/img/porownanie0.png"></td>
              <td><img src="../assets/img/porownanie0.png"></td>
              <td><img src="../assets/img/porownanie3.png"></td>
            </tr>
            <tr>
              <td class="porownanie_td_0">{{$t('compare_packages["attribute6"]')}}</td>
              <td class="text">
                <div class="old-price">{{$t('sets["basic_old_price"]')}}</div>
                <div>{{$t('sets["basic_price"]')}}</div>
              </td>
              <td class="text">
                <div class="old-price">{{$t('sets["advanced_old_price"]')}}</div>
                <div>{{$t('sets["advanced_price"]')}}</div>
              </td>
              <td class="text">
                <div class="old-price">{{$t('sets["premium_old_price"]')}}</div>
                <div>{{$t('sets["premium_price"]')}}</div>
              </td>
            </tr>

            <tr>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td><a class="porownanie_td_order" target="_blank" :href="$t('sets.basic_link')">
                   {{$t('compare_packages["order_btn"]')}}</a>
              </td>
              <td><a class="porownanie_td_order" target="_blank" :href="$t('sets.advanced_link')">
                    {{$t('compare_packages["order_btn"]')}}</a>
              </td>
              <td><a class="porownanie_td_order" target="_blank" :href="$t('sets.premium_link')">
                    {{$t('compare_packages["order_btn"]')}}</a>
              </td>
            </tr>

            </tbody>
          </table>

        </div>
      </div>


    </div>
  </section>
</template>

<script>
  export default {
    name: "ComparePackages"
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ComparePackages.vue